import axios from 'axios'

const getConfig = () => {
	return axios
		.request({
			method: 'get',
			url: '/config2.json',
		})
		.then(function (response) {
			return response.data
		})
}

export default {
	getConfig,
}
